import React, { useMemo } from 'react';
import { useProducts } from '../../contexts/ProductContext';
import { Product, ProductVariant } from '../../types/product';
import ProductCard from '../product/ProductCard';
import './OurPicksSection.css';

const PICK_COUNT = 25;

function matchesOurPicks(item: Product | ProductVariant): boolean {
  const searchText = 'baseId' in item
    ? `${item.name} ${item.category}`
    : `${item.name} ${item.category} ${item.type || ''}`;

  const lower = searchText.toLowerCase();
  return (
    lower.includes('troph') ||
    lower.includes('medal') ||
    lower.includes('champagne') ||
    lower.includes('drinkware')
  );
}

function shuffleArray<T>(list: T[]): T[] {
  const copy = [...list];
  for (let i = copy.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}

const OurPicksSection: React.FC = () => {
  const { trophiesVariants, galwayProducts } = useProducts();

  const picks = useMemo(() => {
    const source: (Product | ProductVariant)[] = [...trophiesVariants, ...galwayProducts]
      .filter(matchesOurPicks);

    if (source.length === 0) {
      return [];
    }

    const shuffled = shuffleArray(source);
    if (shuffled.length >= PICK_COUNT) {
      return shuffled.slice(0, PICK_COUNT);
    }

    const repeated: (Product | ProductVariant)[] = [];
    while (repeated.length < PICK_COUNT) {
      repeated.push(...shuffled);
    }
    return repeated.slice(0, PICK_COUNT);
  }, [trophiesVariants, galwayProducts]);

  const tickerItems = useMemo(() => [...picks, ...picks], [picks]);

  if (picks.length === 0) {
    return null;
  }

  return (
    <section className="our-picks-section">
      <div className="our-picks-container">
        <div className="our-picks-header">
          <h2 className="our-picks-title">Featured Selections</h2>
          <p className="our-picks-subtitle">A curated edit of standout trophies, medals and glassware</p>
        </div>

        <div className="our-picks-ticker-window">
          <div className="our-picks-ticker-track">
            {tickerItems.map((item, index) => {
              const key = 'baseId' in item ? `${item.baseId}-${index}` : `${item.id}-${index}`;
              return (
                <div className="our-picks-item" key={key}>
                  {'baseId' in item ? <ProductCard variant={item} /> : <ProductCard product={item} />}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurPicksSection;

